import(/* webpackMode: "eager" */ "/home/ubuntu/download/69c136047d947e0014795ac6/linksic/src/app/forgot-password/page.tsx");
